'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _modal = require('modal');

var _modal2 = _interopRequireDefault(_modal);

var _decorators = require('decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var ShareModal = (_class = (_temp = _class2 = function (_Modal) {
	_inherits(ShareModal, _Modal);

	function ShareModal() {
		_classCallCheck(this, ShareModal);

		return _possibleConstructorReturn(this, (ShareModal.__proto__ || Object.getPrototypeOf(ShareModal)).apply(this, arguments));
	}

	_createClass(ShareModal, [{
		key: 'openWindow',
		value: function openWindow(url, width, height) {
			var top = (screen.availHeight - height) / 2;
			var left = (screen.availWidth - width) / 2;

			left += screen.availLeft || 0;
			top += screen.availTop || 0;

			window.open(url, '_blank', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=yes,resizable=yes,toolbar=no,location=yes');
		}
	}, {
		key: 'openTwitter',
		value: function openTwitter() {
			this.openWindow('https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.props.title) + '&url=' + encodeURIComponent(this.props.link), 550, 420);
			return false;
		}
	}, {
		key: 'gotFacebookRef',
		value: function gotFacebookRef(node) {
			var _this2 = this;

			ShareModal.loadFacebook(function () {
				return _this2.handleFacebookRef(node);
			});
		}
	}, {
		key: 'handleFacebookRef',
		value: function handleFacebookRef(node) {
			window.FB.XFBML.parse(node);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.clipboardTarget) {
				this.clipboardTarget.destroy();
			}

			if (_get(ShareModal.prototype.__proto__ || Object.getPrototypeOf(ShareModal.prototype), 'componentWillUnmount', this)) {
				_get(ShareModal.prototype.__proto__ || Object.getPrototypeOf(ShareModal.prototype), 'componentWillUnmount', this).call(this);
			}
		}
	}, {
		key: 'setupClipboard',
		value: function setupClipboard(element) {
			if (this.clipboardTarget) {
				this.clipboardTarget.destroy();
				delete this.clipboardTarget;
			}

			if (element) this.clipboardTarget = new _clipboard2.default(element);
		}
	}, {
		key: 'content',
		get: function get() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h3',
					{ className: 'uppercase text-header' },
					'Page Link'
				),
				_react2.default.createElement(
					'div',
					{ className: 'large-input' },
					_react2.default.createElement(
						'h3',
						{ className: 'share-link' },
						this.props.link
					)
				),
				_react2.default.createElement(
					'h3',
					{ className: 'uppercase' },
					_react2.default.createElement(
						'a',
						{ href: 'javascript:void(0)', ref: this.setupClipboard, 'data-clipboard-text': this.props.link },
						'Copy Link'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'social' },
					_react2.default.createElement(
						'h3',
						{ className: 'uppercase text-header' },
						'Share on Social Media'
					),
					_react2.default.createElement(
						'div',
						{ className: 'icons' },
						_react2.default.createElement(
							'div',
							{ className: 'icon-wrap', ref: this.gotFacebookRef },
							_react2.default.createElement('img', { className: 'img-responsive', src: '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/social-white-facebook.png' }),
							_react2.default.createElement('div', { className: 'facebook fb-share-button', 'data-href': this.props.link, 'data-layout': 'icon' })
						),
						_react2.default.createElement('img', { className: 'img-responsive', src: '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/social-white-twitter.png', onClick: this.openTwitter })
					)
				)
			);
		}
	}], [{
		key: 'show',
		value: function show(title, shareLink) {
			this.showModal(_react2.default.createElement(ShareModal, { title: title, link: shareLink }));
		}
	}, {
		key: 'loadFacebook',
		value: function loadFacebook(callback) {
			var _this3 = this;

			if (this.facebookLoaded) {
				setTimeout(callback, 0);
				return;
			}

			this.facebookCallbacks.push(callback);

			if (!this.isWaitingForFacebook) {
				this.isWaitingForFacebook = true;
				window.fbAsyncInit = function () {
					FB.init({ appId: null, version: 'v2.5', cookie: false, status: false, xfbml: false, frictionlessRequests: false, hideFlashCallback: null });
					_this3.didFacebookInit();
				};

				var S = document.createElement('script');
				S.id = 'facebook-jssdk';
				S.src = '//connect.facebook.net/en_US/sdk.js';
				document.body.appendChild(S);
			}
		}
	}, {
		key: 'didFacebookInit',
		value: function didFacebookInit() {
			this.facebookLoaded = true;
			this.handleCallbacks();
		}
	}, {
		key: 'handleCallbacks',
		value: function handleCallbacks() {
			var _this4 = this;

			if (this.facebookCallbacks.length) {
				var cb = this.facebookCallbacks.shift();
				setTimeout(function () {
					cb();
					_this4.handleCallbacks();
				}, 0);
			}
		}
	}]);

	return ShareModal;
}(_modal2.default), _class2.isWaitingForFacebook = false, _class2.facebookLoaded = false, _class2.facebookCallbacks = [], _temp), (_applyDecoratedDescriptor(_class.prototype, 'openTwitter', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'openTwitter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'gotFacebookRef', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'gotFacebookRef'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setupClipboard', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'setupClipboard'), _class.prototype)), _class);
exports.default = ShareModal;